import { FC } from "react"

import { TopBar } from "components/navigation/TopBar"

import { EditorMode, usePromotionEditor } from "./hooks/usePromotionEditor"
import { PromotionEditorForm } from "./PromotionEditorForm"

interface PromotionEditorPageProps {
  mode: EditorMode
  id?: string
  /** Embedded in another view: it owns the heading, and saving returns to its list. */
  embedded?: boolean
  onSaved?: () => void
  onCancel?: () => void
}

export const PromotionEditorPage: FC<PromotionEditorPageProps> = ({ mode, id, embedded, onSaved, onCancel }) => {
  const editor = usePromotionEditor(mode, id, onSaved)
  const pageTitle = mode === "create" ? "Create Promotion" : "Edit Promotion"

  return (
    <div className={embedded ? "grid w-full gap-8 grid-col-1" : "grid w-full gap-8 p-8 pt-0 grid-col-1"}>
      {!embedded && <TopBar title={pageTitle} />}

      {editor.loading ? (
        <div className="flex items-center justify-center py-16">
          <span className="loading loading-spinner loading-lg" />
        </div>
      ) : (
        <PromotionEditorForm mode={mode} editor={editor} onCancel={onCancel} />
      )}
    </div>
  )
}
